import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
// import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import * as STATES from '../../../core/states/player.states';
import './controls.styles.css';
import ThemeContext from '../../../config/themeContext';
import PlayBigIcon from '../../icons/PlayBigIcon';

export default function PlayPauseBig({ videoPlayer, state }) {
  const [playerState, setPlayerState] = useState(state);
  const theme = useContext(ThemeContext);

  useEffect(() => {
    setPlayerState(state);
  }, [state, playerState]);

  function handlerPlayClick() {
    if (playerState === STATES.PAUSED) videoPlayer.resume();
    else if (playerState === STATES.STANDBY) videoPlayer.start();
    else videoPlayer.pause();
  }

  let playPauseIcon =
    state === STATES.PAUSED || state === STATES.STANDBY ? (
      <PlayBigIcon />
    ) : (
      <PauseRoundedIcon sx={theme.imageIconMedium} />
    );
  playPauseIcon = state === STATES.STANDBY ? <PlayBigIcon /> : playPauseIcon;
  return (
    <div className="tpx-playbig" onClick={handlerPlayClick}>
      {playPauseIcon}
    </div>
  );
}

PlayPauseBig.propTypes = {
  videoPlayer: PropTypes.object.isRequired,
  state: PropTypes.string.isRequired,
};
